"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarPropTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cnbuilder = require("cnbuilder");
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));
var _subYears = _interopRequireDefault(require("date-fns/subYears"));
var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));
var _addYears = _interopRequireDefault(require("date-fns/addYears"));
var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));
var _dist = require("react-day-picker/dist");
var _DateTime = require("../Context/l10n/DateTime");
var _Day = _interopRequireDefault(require("./Day"));
var _Header = _interopRequireDefault(require("./Header"));
var _CalendarModule = _interopRequireDefault(require("./Calendar.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DATE_FORMAT = 'MM/dd/yyyy';
const TODAY = new Date();
const Calendar = _ref => {
  let {
    classNameRoot,
    classNameHeader,
    classNameTitle,
    classNamePrevious,
    classNameNext,
    classNameMonthSelect,
    classNameYearSelect,
    classNameDay,
    testAttrHeader,
    testAttrPrevious,
    testAttrNext,
    testAttrTitle,
    testAttrMonthSelect,
    testAttrYearSelect,
    testAttrDay,
    i18nPreviousLabel,
    i18nNextLabel,
    i18nMonthLabel,
    i18nYearLabel,
    id,
    selectedDate,
    initialMonth,
    disablePast,
    disableBefore,
    disableAfter,
    overrideInitialMonthWithSelected,
    navigationType,
    onChange,
    available
  } = _ref;
  const {
    format,
    locale
  } = (0, _DateTime.useL10nDateTimeContext)();
  const formatWeekdayName = day => format(day, 'eee');
  const labelDay = date => format(date, 'EEEE, MMMM do, yyyy');
  const modifierDisabled = d => {
    const day = (0, _startOfDay.default)(d);
    if (available.length) {
      return !available.find(avail => (0, _isSameDay.default)(day, (0, _startOfDay.default)(new Date(avail))));
    }
    let isDayDisabled = false;
    let disableDay = false;
    if (disableBefore) {
      disableDay = (0, _isBefore.default)(day, (0, _startOfDay.default)(new Date(disableBefore)));
      isDayDisabled = disableDay;
    }
    if (disableAfter && !isDayDisabled) {
      disableDay = (0, _isAfter.default)(day, (0, _startOfDay.default)(new Date(disableAfter)));
      isDayDisabled = disableDay;
    }
    if (disablePast && !isDayDisabled) {
      disableDay = (0, _isBefore.default)(day, (0, _startOfDay.default)(TODAY));
    }
    return disableDay;
  };
  const onDayChange = date => {
    if (onChange) {
      onChange(date ? format(date, DATE_FORMAT) : null);
    }
  };
  const isDropdown = navigationType === 'dropdown';
  let firstMonth = initialMonth ? new Date(initialMonth) : null;
  let fromMonth = disablePast ? TODAY : isDropdown ? (0, _subYears.default)(TODAY, 100) : null;
  let toMonth = isDropdown ? (0, _addYears.default)(new Date(), 100) : null;
  if (disableBefore) {
    const beforeDate = new Date(disableBefore);
    if (fromMonth) {
      if ((0, _isAfter.default)(beforeDate, fromMonth)) {
        fromMonth = beforeDate;
      }
    } else {
      fromMonth = beforeDate;
    }
    firstMonth = (0, _isAfter.default)(firstMonth, fromMonth) ? firstMonth : fromMonth;
  }
  if (disableAfter) {
    toMonth = new Date(disableAfter);
  }
  if (selectedDate && overrideInitialMonthWithSelected) {
    firstMonth = new Date(selectedDate);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.DayPicker, _objectSpread(_objectSpread({
    id: id,
    locale: locale,
    className: (0, _cnbuilder.cnb)(_CalendarModule.default.root, classNameRoot),
    classNames: {
      /* eslint-disable camelcase */
      cell: _CalendarModule.default.cell,
      head: _CalendarModule.default.dayTitleContainer,
      head_cell: _CalendarModule.default.dayTitle,
      months: _CalendarModule.default.months,
      table: _CalendarModule.default.days,
      vhidden: 'visually-hidden'
      /* eslint-enable camelcase */
    },
    classNameHeader: classNameHeader,
    classNameTitle: classNameTitle,
    classNamePrevious: classNamePrevious,
    classNameNext: classNameNext,
    classNameMonthSelect: classNameMonthSelect,
    classNameYearSelect: classNameYearSelect,
    classNameDay: (0, _cnbuilder.cnb)(classNameDay, _CalendarModule.default.day),
    testAttrHeader: testAttrHeader,
    testAttrPrevious: testAttrPrevious,
    testAttrNext: testAttrNext,
    testAttrTitle: testAttrTitle,
    testAttrMonthSelect: testAttrMonthSelect,
    testAttrYearSelect: testAttrYearSelect,
    testAttrDay: testAttrDay,
    i18nPreviousLabel: i18nPreviousLabel,
    i18nNextLabel: i18nNextLabel,
    i18nMonthLabel: i18nMonthLabel,
    i18nYearLabel: i18nYearLabel,
    mode: "single",
    defaultSelected: new Date(selectedDate),
    showOutsideDays: true,
    formatters: {
      formatWeekdayName
    },
    labels: {
      labelDay
    },
    disabled: modifierDisabled,
    components: {
      Caption: _Header.default,
      Day: _Day.default
    },
    defaultMonth: firstMonth,
    fromDate: fromMonth,
    toDate: toMonth
  }, isDropdown && {
    captionLayout: 'dropdown'
  }), {}, {
    onSelect: onDayChange
  }));
};
const CalendarPropTypes = exports.CalendarPropTypes = {
  /** Additional class(es) to add to the root element. */
  classNameRoot: _propTypes.default.string,
  /** Additional class(es) to add to the header element. */
  classNameHeader: _propTypes.default.string,
  /** Additional class(es) to add to the month and year title element. */
  classNameTitle: _propTypes.default.string,
  /** Additional class(es) to add to the previous month button element. */
  classNamePrevious: _propTypes.default.string,
  /** Additional class(es) to add to the next month button element. */
  classNameNext: _propTypes.default.string,
  /** Additional class(es) to add to the month select element when `navigationType` is `'dropdown'`. */
  classNameMonthSelect: _propTypes.default.string,
  /** Additional class(es) to add to the year select element when `navigationType` is `'dropdown'`. */
  classNameYearSelect: _propTypes.default.string,
  /** Additional class(es) to add to the each day element. */
  classNameDay: _propTypes.default.string,
  /** The name of the test attribute to associate to the header element. */
  testAttrHeader: _propTypes.default.string,
  /** The name of the test attribute to associate to the month and year title element. */
  testAttrTitle: _propTypes.default.string,
  /** The name of the test attribute to associate to the previous month button element. */
  testAttrPrevious: _propTypes.default.string,
  /** The name of the test attribute to associate to the next month button element. */
  testAttrNext: _propTypes.default.string,
  /** The name of the test attribute to associate to the month select item element when `navigationType` is `'dropdown'`. */
  testAttrMonthSelect: _propTypes.default.string,
  /** The name of the test attribute to associate to the year select item element when `navigationType` is `'dropdown'`. */
  testAttrYearSelect: _propTypes.default.string,
  /** The name of the test attribute to associate to the each day element. */
  testAttrDay: _propTypes.default.string,
  /** The aria-label to apply to the previous month button. */
  i18nPreviousLabel: _propTypes.default.string,
  /** The aria-label to apply to the next month button. */
  i18nNextLabel: _propTypes.default.string,
  /** The aria-label to apply to the month select element when `navigationType` is `'dropdown'`. */
  i18nMonthLabel: _propTypes.default.string,
  /** The aria-label to apply to the year select element when `navigationType` is `'dropdown'`. */
  i18nYearLabel: _propTypes.default.string,
  /** A unique ID which is used to identify this element for accessibility purposes. */
  id: _propTypes.default.string,
  /** A string in the format 'MM/dd/yyyy' representing the date which should be selected on the calendar. */
  selectedDate: _propTypes.default.string,
  /** A string in the format 'MM/dd/yyyy' representing the initial month to show on the calendar. */
  initialMonth: _propTypes.default.string,
  /** Whether to disable the days on the calendar that are in the past. */
  disablePast: _propTypes.default.bool,
  /** A string in the format 'MM/dd/yyyy' representing the date where any day prior is disabled. */
  disableBefore: _propTypes.default.string,
  /** A string in the format 'MM/dd/yyyy' representing the date where any day past is disabled. */
  disableAfter: _propTypes.default.string,
  /** Whether to set the initial month to show in the calendar to the same month as the selected day falls within when a selectedDate is passed. */
  overrideInitialMonthWithSelected: _propTypes.default.bool,
  /** Whether the calendar shows navigation arrows or month and year dropdowns to navigate with. */
  navigationType: _propTypes.default.oneOf(['arrows', 'dropdown']),
  /**
   * Function to execute when the selected date changes.
   *
   * @param {String} selectedDate - The selected date in the format 'MM/dd/yyyy'.
   */
  onChange: _propTypes.default.func,
  /** An array of strings in the format 'MM/dd/yyyy' representing the date that is enabled to select. This will overwrite all other disabled props. */
  available: _propTypes.default.arrayOf(_propTypes.default.string)
};
Calendar.defaultProps = {
  testAttrHeader: 'calendar-header',
  testAttrTitle: 'calendar-title',
  testAttrPrevious: 'calendar-previous',
  testAttrNext: 'calendar-next',
  testAttrMonthSelect: 'calendar-month-select',
  testAttrYearSelect: 'calendar-year-select',
  testAttrDay: 'calendar-day',
  disablePast: true,
  overrideInitialMonthWithSelected: true,
  navigationType: 'arrows',
  available: []
};
var _default = exports.default = Calendar;